import React, { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";

import html2pdf from "html2pdf.js";
import commonLabels from "../../../common/labels/common_en.json";
import label from "../../labels/postExaminationProcessObjective_en.json";
import {
  getExamslistByAdvertisementId,
  getAdvertisementsList,
  getReportCountByAdvtIdAndExamId,
  getDownloadReportCountByAdvtIdAndExamId
} from "../../actions/postExaminationProcessObjectiveActions";
import { getYear } from "date-fns";
import { getYearList, getAdvertisementlistByYear } from "../../../common/actions/commonActions";
import { SET_ALL_REPORT_COUNTS } from "../../../common/constants/ActionTypes";

const DataCount = () => {

  const pdfRef = useRef(null);
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });
  const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [tempselectedAdvertNo, settempSelectedAdvertNo] = useState("");
  const [tempselectedExam, settempSelectedExam] = useState("");
  const [addYear, setAddYear] = useState("");
  const [examName, setExamName] = useState("");
  const [tempExamId, setTempExamId] = useState("");
  const [reloadItem, setReloadItem] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);

  const session = JSON.parse(sessionStorage.getItem("session"));
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0)
    dispatch(getYearList());
    reportCountList.categoryWiseCount && (reportCountList.categoryWiseCount.length = 0);
    reportCountList.subCategoryWiseCount && (reportCountList.subCategoryWiseCount.length = 0);
    reportCountList.centerWiseCount && (reportCountList.centerWiseCount.length = 0);
    setReloadItem(!reloadItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    selectedExam != '' && setTempExamId(selectedExam);
  }, [selectedExam]);
  useEffect(() => { }, [reloadItem]);
  let { examList, advertisementList, reportCountList } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );

  let { yearList, allYearList } = useSelector(
    (state) => state.common,
    shallowEqual
  );
  // const downloadPdf = () => {
  //    // dispatch(getDownloadReportCountByAdvtIdAndExamId(headerDiv,tempExamId));
  //   // setReloadItem(!reloadItem);
  // };



  const downloadPdf = () => {
    const htmlContent = document.createElement('div');
    htmlContent.innerHTML = '<div class="row d-flex flex-column align-items-center"><h5 className="bold-label">' + label.MPSC + '</h5><h5>' + examName + '</h5><h5>' + label.resultCrossCount + '</h5></div>';
    htmlContent.innerHTML += pdfRef.current.innerHTML;

    const options = {
      margin: [0.8, 0.4, 0.8, 0.4],
      filename: '',
      image: { type: 'jpeg', quality: 0.95 },
      html2canvas: { scale: 3, dpi: 300, letterRendering: true },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait', compressPDF: true },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get('pdf')
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth = pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }).split('/').join('/');
          const dateWidth = pdf.getStringUnitWidth(formattedDate) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, textX, textY)

          const ad = tempselectedAdvertNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save('resultCrossCount' + tempExamId + '.pdf');

      });
  };
  const onSubmit = () => {

    dispatch(
      getReportCountByAdvtIdAndExamId(

        selectedAdvertNo,
        selectedExam,

        setSelectedAdvertNo,
        setSelectedExam,

      )
    );
    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
  };

  const onCancelButton = () => {
    setSelectedAdvertNo("");
    setSelectedExam("");
    settempSelectedAdvertNo("");
    setAddYear("");
    setSaveButtonFlag(true);
    dispatch({
      type: SET_ALL_REPORT_COUNTS,
      payload: []
    })
    setReloadItem(!reloadItem);
  };

  const onExamChange = (ele) => {
    let selectedValue = ele;
    setSelectedExam(selectedValue);
    setTempExamId(selectedValue);
    settempSelectedExam(selectedValue)
    if (examList) {

      const filterItem = examList.filter((item) => item.id == selectedValue);

      const selectedName = filterItem[0].name;
      setExamName(selectedName)
      dispatch({
        type: SET_ALL_REPORT_COUNTS,
        payload: []
      })

    }
    setSaveButtonFlag(false);

    setReloadItem(!reloadItem);
  };
  const onAdvertisementChange = (ele) => {
    let selectedValue = ele;
    setSelectedAdvertNo(selectedValue);
    settempSelectedAdvertNo(ele);
    examList.length = 0;
    setSelectedExam("");
    setSaveButtonFlag(true);
    reportCountList.categoryWiseCount && (reportCountList.categoryWiseCount.length = 0);
    reportCountList.subCategoryWiseCount && (reportCountList.subCategoryWiseCount.length = 0);
    reportCountList.centerWiseCount && (reportCountList.centerWiseCount.length = 0);
    selectedValue && dispatch(getExamslistByAdvertisementId(selectedValue));
    dispatch({
      type: SET_ALL_REPORT_COUNTS,
      payload: []
    })
    setReloadItem(!reloadItem);
  };
  const onSelectYear = (ele) => {
    if (ele == "") {
      onCancelButton()
    } else {

      let selectedValue = ele;
      setAddYear(selectedValue);
      advertisementList.length = 0;
      selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
      if (allYearList) {
        allYearList.length = 0
      }
      if (examList) {
        examList.length = 0;
      }
      dispatch({
        type: SET_ALL_REPORT_COUNTS,
        payload: []
      })
      setSaveButtonFlag(true);

      setReloadItem(!reloadItem);
    }
  };

  return (
    <div>
      <h5> {label.DataCount} </h5>

      <div className="row dashboardCards">
        <div className="col-md-12">
          <form name="importForm" encType="multipart/form-data">
            <div className="form-group importFromSection">
              {/* <div className="row">
                <div className="col-md-12">
                  <h5> {label.DataCount}</h5>
                </div>
              </div> */}
              <div className="row">
                <div className="form-group col-md-2">
                  <label className="float-left">
                    {commonLabels.selectYear}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedYear"
                    value={addYear}
                    // ref={register({ required: true })}
                    onChange={(e) => {
                      onSelectYear(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>

                    {yearList &&
                      yearList.length > 0 &&
                      yearList
                        .map((element, index) => (
                          <option key={index} value={element.id} >
                            {element}
                          </option>
                          // <option key={index} value={element.id} >
                          //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          // </option>
                        ))}
                  </select>
                  {_.get("selectedYear.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>

                <div className="form-group col-md-5">
                  <label className="float-left">
                    {commonLabels.SelectAdvertNo}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedAdvertiseNo"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onAdvertisementChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>

                    {allYearList &&
                      allYearList.length > 0 &&
                      allYearList
                        .filter(
                          (element) =>
                            element.isDeleted === false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id} >
                            {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedAdvertiseNo.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
                <div className="form-group col-md-4">
                  <label className="float-left">
                    {label.SelectExam}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedExam"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onExamChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>

                    {examList &&
                      examList.length > 0 &&
                      examList
                        .filter(
                          (element) =>
                            element.isDeleted === false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {element.name}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedExam.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="form-group col-md-6">
                  {(session.roleName == 'superadmin' || session.roleName == 'secretary' || session.roleName == 'desk officer') &&
                    <>          <button
                      type="reset"
                      className="btn btn-secondary mr-2"
                      onClick={() => onCancelButton()}
                    >
                      {commonLabels.BUTTON_CANCEL}
                    </button>
                      <button
                        type="submit"
                        className="btn btn-primary mr-2"
                        disabled={saveButtonFlag}
                        onClick={handleSubmit((e) => {
                          onSubmit(e);
                        })}
                      >
                        {commonLabels.BUTTON_VIEW}
                      </button> </>}
                  {(session.roleName == 'superadmin' || session.roleName == 'secretary') && <button
                    type="button"
                    className="btn btn-primary"
                    disabled={!(reportCountList.centerWiseCount && reportCountList.centerWiseCount.length > 0) && !(reportCountList.subCategoryWiseCount && reportCountList.subCategoryWiseCount.length > 0) && !(reportCountList.categoryWiseCount && reportCountList.categoryWiseCount.length > 0)}
                    onClick={() => {
                      downloadPdf();
                    }}
                  >
                    {commonLabels.BUTTON_PRINT}
                  </button>}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      {reportCountList &&
        ((reportCountList.centerWiseCount &&
          reportCountList.centerWiseCount.length > 0) ||
          (reportCountList.categoryWiseCount &&
            reportCountList.categoryWiseCount.length > 0) ||
          (reportCountList.subCategoryWiseCount &&
            reportCountList.subCategoryWiseCount.length > 0)) ? (
        <div id="resultCount" ref={pdfRef} className="resultCrossCheckCount clear-both">

          {reportCountList &&
            reportCountList.centerWiseCount &&
            reportCountList.centerWiseCount.length > 0 && (
              <div className="catSection mt-0">
                <div className="row">
                  <div className="col-md-12">
                    <h5>{label.CentreWise}</h5>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="countResult">
                      <table className="table table-bordered">
                        {reportCountList &&
                          reportCountList.centerWiseCount &&
                          reportCountList.centerWiseCount.length > 0 &&
                          reportCountList.centerWiseCount.map((Item, index) => {
                            if (index === 0) {
                              return (
                                <thead className="thead-light" key={0}>
                                  <tr>
                                    <th scope="col w-5 text-center">{label.No}</th>
                                    <th scope="col">{label.Name}</th>
                                    <th className="text-center" scope="col w-10">
                                      {label.Count}
                                    </th>
                                  </tr>
                                </thead>
                              );
                            } else {
                              return "";
                            }
                          })}

                        <tbody className="table-font-12">
                          {reportCountList &&
                            reportCountList.centerWiseCount &&
                            reportCountList.centerWiseCount.length > 0 &&
                            reportCountList.centerWiseCount.map(
                              (item, index) => {
                                return (
                                  <tr key={index}>
                                    <td className="w-5 word-break text-center">
                                      {index + 1}
                                    </td>
                                    <td className="word-break ">
                                      {item.name}{" "}
                                    </td>
                                    <td className="word-break w-10 text-center">
                                      {item.count}
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            )}
          {reportCountList &&
            reportCountList.categoryWiseCount &&
            reportCountList.categoryWiseCount.length > 0 && (
              <div className="catSection mt-0">
                <div className="row">
                  <div className="col-md-12">
                    <h5>{label.CategoryWise}</h5>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="countResult">
                      <table className="table table-bordered">
                        {reportCountList &&
                          reportCountList.categoryWiseCount &&
                          reportCountList.categoryWiseCount.length > 0 &&
                          reportCountList.categoryWiseCount.map(
                            (Item, index) => {
                              if (index === 0) {
                                return (
                                  <thead className="thead-light" key={0}>
                                    <tr>
                                      <th scope="col w-5  text-center">{label.No}</th>
                                      <th scope="col">{label.Name}</th>
                                      <th className="text-center" scope="col w-10">
                                        {label.Count}
                                      </th>
                                    </tr>
                                  </thead>
                                );
                              } else {
                                return "";
                              }
                            }
                          )}

                        <tbody className="table-font-12">
                          {reportCountList &&
                            reportCountList.categoryWiseCount &&
                            reportCountList.categoryWiseCount.length > 0 &&
                            reportCountList.categoryWiseCount.map(
                              (item, index) => {
                                return (
                                  <tr key={index}>
                                    <td className="w-5 word-break text-center">
                                      {index + 1}
                                    </td>
                                    <td className="word-break ">
                                      {item.name}{" "}
                                    </td>
                                    <td className="word-break w-10 text-center">
                                      {item.count}
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            )}
          {reportCountList &&
            reportCountList.subCategoryWiseCount &&
            reportCountList.subCategoryWiseCount.length > 0 && (
              <div className="catSection mt-0">
                <div className="row">
                  <div className="col-md-12">
                    <h5>{label.Subcategory}</h5>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="countResult">
                      <table className="table table-bordered">
                        {reportCountList &&
                          reportCountList.subCategoryWiseCount &&
                          reportCountList.subCategoryWiseCount.length > 0 &&
                          reportCountList.subCategoryWiseCount.map(
                            (Item, index) => {
                              if (index === 0) {
                                return (
                                  <thead className="thead-light" key={0}>
                                    <tr>
                                      <th scope="col w-5" className="text-center">{label.No}</th>
                                      <th scope="col">{label.Name}</th>
                                      <th className="text-center" scope="col w-10">
                                        {label.Count}
                                      </th>
                                    </tr>
                                  </thead>
                                );
                              } else {
                                return "";
                              }
                            }
                          )}

                        <tbody className="table-font-12">
                          {reportCountList &&
                            reportCountList.subCategoryWiseCount &&
                            reportCountList.subCategoryWiseCount.length > 0 &&
                            reportCountList.subCategoryWiseCount.map(
                              (item, index) => {
                                return (
                                  <tr key={index}>
                                    <td className="w-5 word-break text-center">
                                      {index + 1}
                                    </td>
                                    <td className="word-break ">
                                      {item.name}{" "}
                                    </td>
                                    <td className="word-break w-10 text-center">
                                      {item.count}
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            )}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default DataCount;
